export default __webpack_public_path__ + "static/media/health-icon-glow.55faae5e.svg";